import React, { Fragment, useState, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AOS from 'aos';

import { loadSanadBranding } from '../utils/loadSanadBranding';



const { config } = require('../../api/api');

function EVisaSanad() {

    
    const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
    const vendor_key = 'c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ==';
    const api_headers = {
        'Authorization': 'Bearer ' + "OMANTEL",
        'Content-Type': 'application/json' // Ensure you're sending JSON
    }
    const base_url = config.baseURL;
    const redirecturl = config.redirectURL;


    const { t } = useTranslation();

 const [isHidePage,setIsHidePage]=useState("");
    const [sanadDetails,setSanadDetails]=useState(null);
    
      const [loading,setLoading]=useState(true); 
      const [countryList,setCountryList]=useState([]);

      const destinationRef = useRef(null);
      const selectOpt1 = useRef(null);
      const selectOpt2 = useRef(null);
      const selectOpt3 = useRef(null);
      const [formData, setFormData] = useState({
        destination_country: 'Oman',
       passport_country: '',
       passport_no:""
      });
      const [error, setError] = useState({});
      const [accessTokenKey, setAccessTokenKey] = useState('');
      const [programDetails,setProgramDetails]=useState('');
      const [countryFlags, setCountryFlags] = useState(null);
      const [openVisaInformation, setOpenVisaInformation] = useState(false); 
      const [openApplicationForm, setOpenApplicationForm] = useState(false); 

      const [destination, setDestination] = useState('');
      const [citizenship, setCitizenship] = useState('');
     const [isChecked, setIsChecked] = useState(false);
     const [requiredDoc,setRequiredDoc]=useState([]);

     const firstNameRef= useRef(null);
     const lastNameRef= useRef(null);
     const emailRef= useRef(null);
     const buildingRef=useRef(null); 
     const floorRef=useRef(null);
     const apartmentRef=useRef(null);
     const streetRef=useRef(null);
     const cityRef=useRef(null);
     const stateRef=useRef(null);
     const phone_noRef=useRef(null);
     const fileRef=useRef(null)

     const [orderId,setOrderId]=useState("");
     const [deepLink,setDeepLink]=useState("");
     const [iframeDeepLinkUrl,setIframeDeepLinkUrl]=useState("");
     const [storedDocs,setStoredDocs]=useState([]);

     const [formSubmit,setFormSubmit]=useState(false);

     const [omrAmount,setOmrAmount]=useState("");

      
   useEffect(() => {

    loadSanadBranding();

  }, []);



       useEffect( () => {
          // debugger;
            // update sanad data in superjet
            const urlSearchString = window.location.search;
            const uparams = new URLSearchParams(urlSearchString);
            const sanadUserName = uparams.get('SANADUSERNAME');
            const sanadRequesteeName = uparams.get('REQUESTEENAME');
            const sanadUserMobileNumber = uparams.get('REQUESTEEMOBILENO');
            const sanadReferenceNumber = uparams.get('SANADREFNUMBER');
            const sanadCivilIDNumber = uparams.get('REQUESTEECIVILNO');
            const sanadPassportNumber = uparams.get('REQUESTEEPASSPORTNO');
            const sanadAccessToken = uparams.get('SANADACCESSTOKEN');
            const sanad_ServiceRequestId = uparams.get('SERVICEREQUESTID');
            const sanad_TransDate = uparams.get('TRANSDATE');
            const sanad_ReturnUrl = uparams.get('RETURNURL');
            const sanad_ErrorUrl = uparams.get('ERRORURL');
            const sanad_BackUrl = uparams.get('BACKURL');
            const sanad_Language = uparams.get('LANGUAGE');

           
          
            
            let sanad_details={
              sanad_user_name:sanadUserName,
              sanad_request_name:sanadRequesteeName,
              mobile_no:sanadUserMobileNumber,
              sanad_reference_no:sanadReferenceNumber,
              sanad_civil_no:sanadCivilIDNumber,
              sanad_passport_no:sanadPassportNumber,
              sanad_request_id:sanad_ServiceRequestId,
              trans_date:sanad_TransDate,
              return_url:sanad_ReturnUrl,
              error_url:sanad_ErrorUrl,
              back_url:sanad_BackUrl,
              language:sanad_Language
              
            }
    
            if (sanadAccessToken === "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluQHNhbmFkLmNvbSIsInBhc3N3b3JkIjoiMTIzNCIsImlhdCI6MTcyODA1MjA0NywiZXhwIjoxNzI4MDUyOTQ3fQ.ucyIy6q6ovSDstXZL1zO-9swTAGYFeypV0uo8_rQJJc") {
                setIsHidePage('success');
                setSanadDetails(sanad_details);
                setFormData((prev)=>({...prev,passport_no:sanadPassportNumber || ""}));
            } else {
                setIsHidePage('fail');
            }
            // var sanad_urls_data = {
            //     'back_url': sanad_BackUrl,
            //     'return_url': sanad_ReturnUrl,
            //     'error_url': sanad_ErrorUrl,
            // }
            // debugger
            //    sessionStorage.setItem("sanadUrlData", JSON.stringify(sanad_urls_data));
            // const expiryDate = new Date();
            // expiryDate.setTime(expiryDate.getTime() + (1 * 60 * 60 * 1000));
            // Cookies.set('sanadUrlData', JSON.stringify(sanad_urls_data), { expires: expiryDate });
           
        }, []);

        

        const handleChange = (e) => {
   
            const { name, value } = e.target;
          const trimValue = value.trimStart(); // allow spaces at end while typing

          
      

  // Fields with only letters and spaces
  const letterFields = [
    "first_name", "last_name"
  ];
  const nameRegex = /^[A-Za-z\s]*$/;
  // const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
   const emailRegex =  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
   const numberRegex = /^[0-9]*$/;

  if (letterFields.includes(name)) {
    if (nameRegex.test(trimValue)) {
      setFormData({ ...formData, [name]: trimValue });
    }
    return; // stop here so we don't run email logic
  }

  if (name === "email") {
     setFormData({ ...formData, [name]: trimValue });
     
//   let emailPattern= /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//      if(trimValue.length>10){
//     if (emailPattern.test(trimValue)) {
//       setError((prev)=>({
//      ...prev,email:""
//       }));
//     }
//     else{
//  setError((prev)=>({
//      ...prev,email:"Invalid email address."
//       }));
//     }
//     }

    return;
  }
  if (name === "phone_no") {
    
    if (numberRegex.test(trimValue) && trimValue.length<=15 ) {
      setFormData({ ...formData, [name]: trimValue });
    }
    return;
  }
 
  



  // Default for other fields
  setFormData({ ...formData, [name]: trimValue });  
          //    if (name==="email") {
          //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          //    if(emailRegex.test(trimValue)){
          //     setFormData({ ...formData, [name]: trimValue });
          //   }
          //   else{
          //   // setFormData({ ...formData, [name]: trimValue });
          //   return

          //   }
          // } 
            
        }
         const handleValidation = (e) => {
          // debugger

              const { name } = e.target;
              if(name==="email"){

                let emailPattern= /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

                if(!formData.email || formData.email.length===0){
                      setError((prev)=>({
                       ...prev,email:"Email is required"
                       }));
                       return;
                }
                else if(formData.email){
                  if(emailPattern.test(formData.email)){
                    setError((prev)=>({
                       ...prev,email:""
                       }));
                  }
                  else{
                     setError((prev)=>({
                       ...prev,email:"Invalid email address."
                       }));
                  }
                }

              }
              else if(name==='phone_no'){
                if(formData.phone_no.length===0){
                      setError((prev)=>({
                       ...prev,[name]:"Phone no is required"
                       }));
                }
                else if(formData.phone_no.length<5){
                    setError((prev)=>({
                       ...prev,[name]:"Phone no must be at least 5 digits."
                       }));
                }
                else if(formData.phone_no.length>=5){
                    setError((prev)=>({
                       ...prev,[name]:""
                       }));
                }
              }
             else if (!formData[name]?.trimStart()) {
      setError((prev) => ({ ...prev, [name]:name.replace("_"," ").charAt(0).toUpperCase()+name.replace("_"," ").substring(1)+" is required"  }));
             }
             else if(formData[name]?.trimStart()){
      setError((prev) => ({ ...prev, [name]:"" }));
             }


         }




//       const handleFileValidation = (event, documentType) => {
//   const files = Array.from(event.target.files);

//   if (files.length > 0) {
//     setError((prev) => ({ ...prev, [documentType]: "" }));
//   }

// };




          const createAccessToken = async () => {
    // debugger
    try {
        const response = await fetch(base_url + '/sanad_access_token', {
            method: 'GET',
            headers: api_headers
        });
        const data = await response.ok ? await response.json() : Promise.reject('Network response was not ok');
        if (data.message === 'success') 
          
        {
          
            return data;
        } else {
            return null;
        }
    } catch (error) {
      console.error("Error fetching access token:", error);
        return null;
    }
};



            const getCountryList = async () => {
      // debugger
    
      try {
          const response = await fetch(base_url + '/country', {
              method: 'POST',
              headers:{
                "Content-Type":"application/json"
              },
              body: JSON.stringify({
                  vendor_key: vendor_key // Serializing the body as JSON
              })
          });
          const data = await response.ok ? await response.json() : Promise.reject('Network response was not ok');
          if (data.message === 'success') {
              setCountryList(data.result);
              // setRelationList(data?.result?.data);
          }
      } catch (error) {
          console.error('Error fetching country list:', error);
         
      }
      finally{
        setLoading(false)
      }
  };

      useEffect(() => {
        // debugger
             const fetchData = async () => {

                    await getCountryList();

             };
     
             fetchData();
         }, []);


         const handleCountryChange = (name, value) => {
          // debugger
        
              if(value && value!=="--select--"){
                   setFormData((prevData) => ({
                ...prevData,
                [name]: value
              }));
           const filterCountry=countryList.filter((country) => country.country === value);
            setFormData((prevData) => ({
                  ...prevData,
                  country_code: filterCountry[0].country_code
              }
            ));
            setError((prev)=>({...prev,country:""}));


          }
          else{

             setFormData((prevData) => ({
                  ...prevData,
                  country_code: ""
              }
            ));
               setError((prev)=>({...prev,country:"Country is required."}));

          }
         }
    
       const   handleValidationPassportCountry = (name,value) => {

            if (!value || value==="--select--") {

                setError((prevError) => ({
                    ...prevError,
                    [name]: 'Passport country is required'  
                }));
                setFormData((prevData) => ({
                ...prevData,
                [name]: ""
              }));
            } else {
              setFormData((prevData) => ({
                ...prevData,
                [name]: value
              }));
                setError((prevError) => ({  
                    ...prevError,
                    [name]: ''
                }));
            }
        };
 const   handleValidationDestinationCountry = (name,value) => {
            if ((!value || value==="--select--" )&& !formData.destination_country) {

                setError((prevError) => ({
                    ...prevError,
                    [name]: 'Destination country is required'  
                }));
                setFormData((prevData) => ({
                ...prevData,
                [name]: ""
              }));
            } else {
              setFormData((prevData) => ({
                ...prevData,
                [name]: value
              }));
                setError((prevError) => ({  
                    ...prevError,
                    [name]: ''
                }));
            }
        };


          useEffect(() => {
                   const $select = $(selectOpt1.current);
                 
                   // Initialize Select2
                   
                   $select.select2({ width: "100%"})
                 
                   // Define event handlers
                   const handleSelect = (e) => {
                    //  debugger
                     const selectedValue= e.params.data.id;
                     handleValidationPassportCountry("passport_country", selectedValue);

                 
                   };
                 
                   if(formData.passport_country){
                    $select.val(formData.passport_country).trigger("change");
                   }
                  
                 
                   // Attach handlers
                   $select.on('select2:select',(e)=> handleSelect(e));
                            
                 
                   // Cleanup
                   return () => {
                     $select.off('select2:select', handleSelect);
                     $select.select2('destroy');
                   };
                 }, [countryList]);
                 
          useEffect(() => {
                   const $select = $(selectOpt3.current);
                 
                   // Initialize Select2
                   
                   $select.select2({ width: "100%"})
                 
                   // Define event handlers
                   const handleSelect = (e) => {
                    //  debugger
                     const selectedValue= e.params.data.id;
                    //  ("destination_country", e.params?.originalSelect2Event?.data?.id || formData.destination_country);

                     handleValidationDestinationCountry("destination_country", selectedValue);

                 
                   };
                 
                   if(formData.destination_country){
                    $select.val(formData.destination_country).trigger("change");
                   }
                  
                 
                   // Attach handlers
                   $select.on('select2:select',(e)=> handleSelect(e));
                            
                 
                   // Cleanup
                   return () => {
                     $select.off('select2:select', handleSelect);
                     $select.select2('destroy');
                   };
                 }, [countryList]);


                    useEffect(() => {
                   const $select = $(selectOpt2.current);
                 
                   // Initialize Select2
                   
                   $select.select2({ width: "100%"})
                 
                   // Define event handlers
                   const handleSelect = (e) => {
                    //  debugger
                     const selectedValue= e.params.data.id;
                     handleCountryChange("country", selectedValue);

                 
                   };
                 
                   if(formData.country){
                    $select.val(formData.country).trigger("change");
                   }
                  
                 
                   // Attach handlers
                   $select.on('select2:select',(e)=> handleSelect(e));
                            
                 
                   // Cleanup
                   return () => {
                     $select.off('select2:select', handleSelect);
                     $select.select2('destroy');
                   };
                 }, [countryList,openApplicationForm]);

 


  const findingEvisa = async (e) => {


    e.preventDefault();



    // debugger
    setOpenVisaInformation(false);
    setOpenApplicationForm(false);
    setError({});
    setFormSubmit(false);
    

    var valid =true;

     if (!formData.destination_country ||formData.destination_country==="--select--" ) {
    // alert('Please select a destination country.');
    setError((prevError) => ({
                    ...prevError,
                    destination_country: 'Passport country is required'  
                }));
    valid= false;
  }

  if (!formData.passport_country || formData.passport_country==="--select--") {
    // alert('Please select a passport country.');
    setError((prevError) => ({
                    ...prevError,
                    passport_country: 'Passport country is required'  
                }));
    valid= false;
  }
  if(valid){
  setDestination(formData.destination_country);
    setCitizenship(formData.passport_country);

    if (formData.passport_country && formData.destination_country) {
        setLoading(true);
        try {
            const response = await fetch(base_url + '/get_visa_programs_sanad', {
                method: 'POST',
                headers: api_headers,
                body: JSON.stringify({
                    citizenship: formData.passport_country,
                    destination:formData.destination_country
                    // destination: formData.destination_country
                })
            });
            const data = await response.ok ? await response.json() : Promise.reject('Network response was not ok');
            if (data.message === 'success') {
        
              if(data.result.programs.length > 0) {

              setProgramDetails(data.result.programs);
              setCountryFlags(data.country_flags);
              setOpenVisaInformation(true);
                setFormData({
                    ...formData,
                    visa_fee: null,
                });
              // debugger

              if(data.result.programs[0].available && data.result.programs[0].required){

             
                await getOMRAmount(data.result.programs[0].fee,data.result.programs[0].currency);

                setFormData({
                    ...formData,
                    visa_fee: data.result.programs[0].fee + ' ' + data.result.programs[0].currency,
                    first_name: '',
                    last_name: '',
                    email: '',
                    building: '',
                    floor: '',
                    apartment: '',
                    street: '',
                    city: '',
                    state: '',
                    country: '',
                    phone_no: '',
                    country_code:""
                });


                

                const docResponse= await fetch(base_url+"/visa_required_doc",{
                  method:"POST",
                  headers:{
                    "Authorization":"Bearer "+vendor_key,
                    "Content-Type":"application/json"
                  },
                  body:JSON.stringify({destination:formData.destination_country})

                });
                const docData= await docResponse.json();
                if(docData.message==="success"){
                  if(docData.result.length>0){

               const arr = Array(docData.result.length).fill(null);
                        setStoredDocs(arr);

                        setRequiredDoc(docData.result);
                  }
                    
                }
                setOpenApplicationForm(true);

                // toast.success("Available")
              }
              }
              else{
                toast.error("Programs not found.")
              }
            }
        
        } catch (error) {
            console.error('Error finding eVisa:', error);
           
        }
        finally{
          setTimeout(()=>{
           setLoading(false);
          },1000)
       
        }
    }
  }
};  



   const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    
  };

     function generateRandomValue() {
                    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                    let randomValue = '';
                    for (let i = 0; i < 10; i++) {
                      randomValue += chars.charAt(Math.floor(Math.random() * chars.length));
                    }
                    return randomValue;
                  }


const handleSubmitApplication = async() => {
  let newErrors = {};
  let emailPattern= /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

//  debugger
  // Stage 1: Show all errors at once
  if (!formData.first_name) {
    newErrors.first_name = "First name is required";
  }
  if (!formData.last_name) {
    newErrors.last_name = "Last name is required";
  }
  if (!formData.email ||formData.email.length===0) {
    newErrors.email = "Email is required";
  }
  if(formData.email.length>0 && !emailPattern.test(formData.email)){
    newErrors.email = "Invalid email address.";
  }
  if (!formData.building) {
    newErrors.building = "Building is required";
  }
  if (!formData.floor) {
    newErrors.floor = "Floor is required";
  }
  if (!formData.apartment) {
    newErrors.apartment = "Apartment is required";
  }
  if (!formData.street) {
    newErrors.street = "Street is required";
  }
  if (!formData.city) {
    newErrors.city = "City is required";
  }
  if (!formData.state) {
    newErrors.state = "State is required";
  }
  if (!formData.country) {
    newErrors.country = "Country is required";
  }
  if(!formData.phone_no || formData.phone_no.length===0){
       newErrors.phone_no = "Phone no is required";
   }
  if(formData.phone_no && formData.phone_no.length<5){
        newErrors.phone_no ="Phone no must be at least 5 digits.";
   }
  // if(!formData.doc.required_documents){
  //    newErrors.fileRef = "files upload is required";
  // }
  // if(!storedDocs.fileRef){

  //  newErrors.fileRef = "Required";
  // }
  // if(storedDocs){
  //   newErrors.fileRef=""
  // }

  setError(newErrors);

  setFormSubmit(true);

 




  if (Object.keys(newErrors).length > 0) {
    // Stage 2: Focus the first empty field
    const firstErrorField = Object.keys(newErrors)[0];
    switch (firstErrorField) {
      case "first_name":
        firstNameRef.current.focus();
        break;
      case "last_name":
        lastNameRef.current.focus();
        break;
      case "email":
        emailRef.current.focus();
        break;
      case "building":
        buildingRef.current.focus();
        break;
      case "floor":
        floorRef.current.focus();
        break;
      case "apartment":
        apartmentRef.current.focus();
        break;
      case "street":
        streetRef.current.focus();
        break;
      case "city":
        cityRef.current.focus();
        break;
      case "state":
        stateRef.current.focus();
        break;
      case "phone_no":
        phone_noRef.current.focus();
        break;
      default:
        break;
    }
    return; // stop here until fixed
  }

  
  for(let i=0;i<storedDocs.length;i++){
    if(!storedDocs[i]){
      return;
    }
  }


  // // If no errors, check declaration
  // if (!isChecked) {
  //   alert("Declaration required..!!!");
  //   return;
  // }

  // All good
  
try{
   setLoading(true);
  const req_data={
        "email": formData.email,
        "first_name": formData.first_name,
        "last_name": formData.last_name,
        "phone":formData.phone_no,
        "country_code":formData.country_code,
        "civil_no":formData.civil_no,
        "building":formData.building,
        "floor":formData.floor,
        "apartment":formData.apartment,
        "street":formData.street,
        "city":formData.city,
        "state":formData.state,
        "country":formData.country
}
  
  

  const response = await fetch(base_url+"/sanad_create_traveller",{
    method:"POST",
    headers:{
      "Authorization":"Bearer "+vendor_key,
      "Content-Type":"application/json"
    },
    body:JSON.stringify(req_data)
  });
  const data =await response.json();
  if(data.message==="success"){
const user_token=data.result[0].access_token;

//if upload docs api 

// const response=await fetch(base_url+"/")/
 var  uploaded_document_details=[];
    if(requiredDoc?.length > 0)  {
         
        for(let k=0;k<storedDocs.length;k++){

          const each_file=storedDocs[k];
            const file_name=each_file?.name;
            if(file_name){
            // const extension=file_name.substring(file_name.lastIndexOf('.')).toLowerCase();
            const formData=new FormData();
            formData.append("image",each_file);
            formData.append("document_type",requiredDoc[k].required_documents)
            const response = await fetch(base_url+'/upload_documentss3',{
              method:"POST",
              headers:{
                "Authorization":"Bearer "+vendor_key
              },
              body:formData
            })
            if(response.ok){
            const data=await response.json();
            if(data.message==="File uploaded successfully"){
              //  const get_card_details=localStorage.getItem("added_card_details");
              //  const parse_card=get_card_details && JSON.parse(get_card_details);
            const obj={
                document_type:requiredDoc[k].required_documents,
                document:data.fileUrl
            }
            uploaded_document_details.push(obj);
            }
            }
          }
        }
        
      
      }

const order_data={
    arrival:citizenship ,
    commission: programDetails[0].commision,
    commission_type: programDetails[0].commision_type ? programDetails[0].commision_type :"flat rate",
    country: formData.country,
    description: "Visa Order",
    destination: destination,
    email: formData.email,
    fee: programDetails[0].fee,
    currency:programDetails[0].currency,
    first_name: formData.first_name,
    last_name: formData.last_name,
    phone_no: formData.phone_no,
    passport_no:formData.passport_no,
    program_id: programDetails[0].id,
    quantity: 1,
    reference_no: generateRandomValue(),
    uploaded_docs:uploaded_document_details,
    vendor_key: vendor_key,
    address_details:{
       phone:formData.phone_no,
        country_code:formData.country_code,
        civil_no:formData.civil_no,
        building:formData.building,
        floor:formData.floor,
        apartment:formData.apartment,
        street:formData.street,
        city:formData.city,
        state:formData.state,
        country:formData.country
    },
     sanad_details:{
         sanad_data:sanadDetails,
         sanad_user_name:sanadDetails.sanad_user_name,
         sanad_request_name:sanadDetails.sanad_request_name,
         sanad_request_id:sanadDetails.sanad_request_id,
         sanad_reference_no:sanadDetails.sanad_reference_no
        }
}

 const orderResponse = await fetch(base_url+"/sanad_iframe_order_evisa",{
    method:"POST",
    headers:{
      "Authorization":"Bearer "+user_token,
      "Content-Type":"application/json"
    },
    body:JSON.stringify(order_data)
  });
    

  const orderData=await orderResponse.json();
  if(orderData.message==="success"){
    setOrderId(orderData.result.order_id);
    setDeepLink(orderData.result.deeplink);
    setIframeDeepLinkUrl(orderData.result.iframe_deeplink_url); 
    sessionStorage.setItem("programs",JSON.stringify(programDetails[0]))
    sessionStorage.setItem("user_details",JSON.stringify({...formData,access_token:user_token}));  
    sessionStorage.setItem("deeplink",JSON.stringify(orderData));
    window.location.href="/sanad-evisa-iframe"
  }
  else if(orderData.message==="alert"){
    // alert(orderData.desc);
      toast.error(orderData.desc);
  }
  }
}catch(err){
  console.error("err message : "+err.message);
}
finally{
  setLoading(false);
}
};


  const getOMRAmount = (amount, currency) => {
   
// debugger
    fetch(base_url+'/amount_convertion', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "amount":amount,
        "currency": currency
    }),
    })
      .then(response => response.json())
      .then(data => {
        // debugger;
        if(data['message'] == 'success'){
          var result = data['result'];
          var split_data = result.split('.');
          var convertion_amount = '';
          if(split_data[1].length >= 3){
            convertion_amount = split_data[0] +'.'+ result.split('.')[1].substring(0, 3);
          }else{
            convertion_amount = result;
          }
          setOmrAmount(convertion_amount+" OMR");
        }
       else{
        setOmrAmount(formData.visa_fee + programDetails[0].currency)
       }
        // setVendorKey(data.result[0].vendor_key);
      })
      .catch(error => {
        console.error('Error posting data:', error);
      })
   
   
  };




const handleFileChange = (e, index) => {

  // debugger
  const allowedTypes = ["jpeg", "jpg", "png", "pdf"];

  const file = e.target.files[0];
  if (!file) return;

  const fileExt = file.type.split("/").pop().toLowerCase();
  if (!allowedTypes.includes(fileExt)) {
    // alert("Only JPEG, JPG, PNG, or PDF files are allowed.");
    toast.warning("Only JPEG, JPG, PNG, or PDF files are allowed.")
    e.target.value = "";
    return;
  }

  // Clone state immutably
  const newDocs = [...storedDocs];
  newDocs[index] = file;
  setStoredDocs(newDocs);

  // Reset input
  e.target.value = "";
};



const handleDeleteFile = (index) => {
  const newDocs = [...storedDocs]; 
  newDocs[index] = null; 
  setStoredDocs(newDocs); 
};

const handleClickBtnFile=(e,file_name)=>{

const fileElement =document.getElementById(file_name);
if(fileElement){
  fileElement.click();
}
}

   return (


   isHidePage === 'success' ? 
          <Fragment>
              <form className="container-fluid mt-4  " >
                 
                 
                  <>
                  <div className="row "  >
                      <div className="col-lg-12 col-md-12">
                          <div>
                              <div className="row mb-3">
                                  <div className="col-lg-6 col-md-6 text-start">
                                      <h2>Start Your eVisa Application </h2>
                                  </div>
                                  <div className="col-lg-6 col-md-6 text-right">
                                   ابدأ في تقديم طلب التأشيرة الإلكترونية الخاصة بك 
                                  </div>
                              </div>
  
  
                              <div className='inside_visa-form '>
                                  <div className="row mb-5">
                          <div className='col-lg-4  col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Destination Country <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>بلد المقصد</span></label>

                  
                   <select ref={selectOpt3}  name="destination_country" className="form-control" value={formData?.destination_country} 
                  onChange={handleChange}
                  onBlur={handleValidation} >
        <option value={null}>--select--</option>
        {countryList.length>0 && countryList.map((option, index) => (
          <option key={index} value={option.country}>
            {option.country}
          </option>
        ))}
        </select>
                  
                  {error?.destination_country && <p style={{ color: 'red' }}>{error?.destination_country}</p>}
                </div>
                    <div className='col-lg-4 col-md-6  mt-3   '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Passport Country <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>بلد جواز السفر</span></label>


                  <select ref={selectOpt1}  name="passport_country" className="form-control" value={formData?.passport_country} 
                  onChange={handleChange}
                  onBlur={handleValidation} >
        <option value={null}>--select--</option>
        {countryList.length>0 && countryList.map((option, index) => (
          <option key={index} value={option.country}>
            {option.country}
          </option>
        ))}
        </select>
                  {error?.passport_country && <p style={{ color: 'red' }}>{error?.passport_country}</p>}
                </div>

              {/* find  button  */}
              <div className="col-lg-4 mt-3">
              <div className="d-flex justify-content-start " style={{position:"relative",top:"32px"}}>
              <button type="button" className="px-5" onClick={(e) => {
                 findingEvisa(e);
              }}>
                  {'Find e-Visa'}
              </button>
</div>
              </div>
                </div>
               
</div>

{/* visa information */}
{openVisaInformation &&<div className={`inside_visa-form mt-5 `} style={{marginBottom:`${openApplicationForm===false?"100px":"0px"}`}}>


 <div className="row mb-3">
                                  <div className="col-lg-6 col-md-6 text-start">
                                      <h2>Visa Information </h2>
                                  </div>
                                  <div className="col-lg-6 col-md-6 text-right">
                                    معلومات التأشيرة
                                  </div>
                            </div>
 <div className="row mb-3">
{/* flag image  */}



  <div className="col-lg-12 col-md-12">
  <div className="inside_visa-form pb-5">
  <div className="row">
  <div className="col-lg-12 col-md-12">

  {/* set available and not available condition */}

  {/* available */}
    {  ((programDetails[0].available===true && programDetails[0].required===false) ||
    (programDetails[0].available===true && programDetails[0].required===true) )&&  
      <div style={{textAlign:"center",marginBottom:"10px"}}>
        <span style={{border:"1px solid green",borderRadius:"20px",fontSize:"14px",padding:"5px 10px",color:"green"}}>Available</span>
      </div>}

{/* not available */}
      {((programDetails[0].available===false && programDetails[0].required===false) ||
    (programDetails[0].available===false && programDetails[0].required===true) )&&  
          <div style={{textAlign:"center",marginBottom:"20px"}}>
        <span style={{border:"1px solid red",borderRadius:"20px",fontSize:"14px",padding:"5px 10px",color:"red"}}>Not Available</span>
      </div>

      }
  </div>
    <div className="col-lg-3 col-md-3 mt-3 d-flex"style={{alignItems:"center"}}>
<img src={countryFlags.to} alt="Oman Flag" style={{ width: '90%', height: 'auto' }} />

    </div>
    <div className="col-lg-9 col-md-9 mt-3">
    {/* visa given details */}
 <table >
    <tbody>
      <tr >
        <td  >
        Destination 
        </td>
        <td  >
        <span>:&nbsp;</span><b> {destination}</b>
        </td>
          </tr>
           <tr>
        <td >
        citizenship 
        </td>
        <td  >
         <span>:&nbsp;</span><b> {citizenship}</b>
        </td>
         </tr>
      { formData.visa_fee && <tr>
        <td >
        Visa Charges  
        </td>
        <td  >
         <span>:&nbsp;</span><b> { omrAmount}</b>
        </td>
        </tr>
      }
     {  programDetails[0].max_stay &&  <tr>
          <td>
          Max Stay 
          </td>
          <td>
           <span>:&nbsp;</span> <b>  {programDetails[0].max_stay} Days</b>
          </td>
         </tr>
         }
    </tbody>
  </table>

  {/* based on country result */}

  {/* dont need visa  */}
 {        (programDetails[0].available===true && programDetails[0].required===false) && 
    <>
             <div className="mt-3 mb-3">
         <div>A visa is not required for you visit.</div>
     
         <div  style={{marginBottom:"10px"}}>{programDetails[0].label}</div>  
         </div>
         <div className="border" style={{padding:"10px",borderRadius:"10px"}}>
          <h4><b>you are good to go!</b></h4>
          <div>You don't need a visa for {formData.destination_country} if you have a passport from {formData.passport_country}</div>
         </div>
   </>
           
  }


  {/* dont need visa but not available */}

 {       ( programDetails[0].available===false && programDetails[0].required===false) && 
 <>
     <div   className="mt-3 mb-3">
    
        <div>A visa is not required for you visit.</div>

         <div  >{programDetails[0].label}</div> 
</div>
       <div>
         <div style={{marginBottom:"0px"}}>You don't need a visa for <b>{formData.destination_country}</b> if you have a passport from <b>{formData.passport_country}</b></div>
          

      <div  className=" mt-3 border d-flex justify-content-center">
          <div className="p-3">This visa program is currently <b>unavailable</b> or does not meet the specified criteria.</div>
         
      </div>
        
     </div>
       </>    
  }

  {/* visa required but not available  */}

    {       ( programDetails[0].available===false && programDetails[0].required===true) && 
    <>

    <div className="mt-3 mb-3">
       <div  >{programDetails[0].label}</div> 
    </div>
      <div className="border d-flex justify-content-center">
          <div className="p-3">This visa program is currently <b>unavailable</b> or does not meet the specified criteria.</div>
      
      </div>
        </>

           
  }

    </div>
</div>
  </div>

  </div>

  <div  >

<div>
  
 




  </div>
  </div>
  
  </div>


</div>}

{/* application form */}
 {  openApplicationForm && <div className="inside_visa-form mt-5">
  
<h2>Application Form</h2>
<div className="row mb-2">
                          <div className='col-lg-4 col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>First Name <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>الاسم الأول</span></label>

                   <input
                    type='text'
                    className='form-control'
                    ref={firstNameRef}
                    value={formData.first_name}
                    name='first_name'
                    onChange={handleChange}
                    onBlur={handleValidation}
                    // onFocus={()=>handleValidation("first_name")}
                 
                  />
                  
                  {/* {error?.first_name && <p style={{ color: 'red' }}>{error?.first_name}</p>} */}
                  {error?.first_name && <p style={{ color: 'red' }}>{error.first_name}</p>}
                </div>

                     <div className='col-lg-4 col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Last Name <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>  اسم العائلة</span></label>

                   <input
                    type='text'
                    className='form-control'
                    ref={lastNameRef}
                    value={formData.last_name}
                    name='last_name'
                    onChange={handleChange}
                    onBlur={handleValidation}
                    // onFocus={()=>handleValidation("last_name")}
                 
                  />
                  
                  {error?.last_name && <p style={{ color: 'red' }}>{error?.last_name}</p>}
                </div>
{/* email */}
                   <div className='col-lg-4 col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Email <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>بريد إلكتروني</span></label>

                   <input
                    type='text'
                    className='form-control'
                    ref={emailRef}
                    value={formData.email}
                    name='email'
                    onChange={handleChange}
                    onBlur={handleValidation}
                
                  />
                  
                  {error?.email && <p style={{ color: 'red' }}>{error?.email}</p>}
                </div>
                {/* Building */}
   <div className='col-lg-4 col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Building <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>مبنى </span></label>

                   <input
                    type='text'
                    className='form-control'
                    ref={buildingRef}
                    value={formData.building}
                    name='building'
                    onChange={handleChange}
                    onBlur={handleValidation}
                 
                  />
                  
                  {error?.building && <p style={{ color: 'red' }}>{error?.building}</p>}
                </div>
                {/* floor */}
                  <div className='col-lg-4 col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Floor <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>أرضية </span></label>

                   <input
                    type='text'
                    className='form-control'
                    ref={floorRef}
                    value={formData.floor}
                    name='floor'
                    onChange={handleChange}
                    onBlur={handleValidation}
                 
                  />
                  
                  {error?.floor && <p style={{ color: 'red' }}>{error?.floor}</p>}
                </div>
                {/* Apartment */}
                    <div className='col-lg-4 col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Apartment <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>شقة </span></label>

                   <input
                    type='text'
                    className='form-control'
                    ref={apartmentRef}
                    value={formData.apartment}
                    name='apartment'
                    onChange={handleChange}
                    onBlur={handleValidation}
                 
                  />
                  
                  {error?.apartment && <p style={{ color: 'red' }}>{error?.apartment}</p>}
                </div>
{/* street */}
      <div className='col-lg-4 col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Street <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>شارع </span></label>

                   <input
                    type='text'
                    className='form-control'
                     ref={streetRef}
                    value={formData.street}
                    name='street'
                    onChange={handleChange}
                    onBlur={handleValidation}
                 
                  />
                  
                  {error?.street && <p style={{ color: 'red' }}>{error?.street}</p>}
                </div>
{/* city */}
      <div className='col-lg-4 col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>City <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>مدينة </span></label>

                   <input
                    type='text'
                    className='form-control'
                     ref={cityRef}
                    value={formData.city}
                    name='city'
                    onChange={handleChange}
                    onBlur={handleValidation}
                 
                  />
                  
                  {error?.city && <p style={{ color: 'red' }}>{error?.city}</p>}
                </div>

                {/* State */}
                 <div className='col-lg-4 col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>State <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>ولاية </span></label>

                   <input
                    type='text'
                    className='form-control'
                     ref={stateRef}
                    value={formData.state}
                    name='state'
                    onChange={handleChange}
                    onBlur={handleValidation}
                 
                  />
                  
                  {error?.state && <p style={{ color: 'red' }}>{error?.state}</p>}
                </div>
 {/* country */}
                 <div className='col-lg-4 col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Country <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>دولة </span></label>

                 <select ref={selectOpt2}  name="country" className="form-control" value={formData?.country} 
                  onChange={handleChange}
                  //  ref={countryRef} 
                  onBlur={handleValidation} >
        <option value={null}>--select--</option>
        {countryList.length>0 && countryList.map((option, index) => (
          <option key={index} value={option.country}>
            {option.country}
          </option>
        ))}
        </select>
                  
                  {error?.country && <p style={{ color: 'red' }}>{error?.country}</p>}
                </div>

                 {/* Phone No */}
                 <div className='col-lg-4 col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Phone No <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>رقم التليفون </span></label>

<div className="d-flex">
                      <input
                    type='text'
                    className='w-25 form-control  text-center'
                    disabled
                    value={formData?.country_code}
                    name='country_code'
                    onChange={handleChange}
                    onBlur={handleValidation}
                   style={{borderRadius:"0px",borderTopRightRadius:'0px',borderBottomRightRadius:'0px'}}
                  />
                  

                   <input
                    type='text'
                    className='w-75 form-control'
                     ref={phone_noRef}
                    value={formData?.phone_no}
                    name='phone_no'
                    onChange={handleChange}
                    onBlur={handleValidation}
                   style={{borderRadius:"0px",borderTopleftRadius:'0px',borderBottomleftRadius:'0px'}}
                  />
                  </div>
                  
                  {error?.phone_no && <p style={{ color: 'red' }}>{error?.phone_no}</p>}
                </div>

                 {/* passport no */}
                  <div className='col-lg-4 col-md-6 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Passport No <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>رقم جواز السفر</span></label>

                   <input
                    type='text'
                    className='form-control'
                    value={formData?.passport_no}
                    disabled={true}
                    name='passport_no'
                    // onChange={handleChange}
                    // onBlur={handleValidation}
                 
                  />
                  
                  {/* {error?.passport_no && <p style={{ color: 'red' }}>{error?.passport_no}</p>} */}
                </div>

</div>



{/* req doc details */}

{requiredDoc.length > 0 &&
    <div className="row">
     <div className="col-lg-12 mt-4 ">
    <h3>Document Requirements for Australia</h3>
    <div className="border" style={{padding:"20px" ,borderRadius:"10px"}}>
       <div>
         
       
        
      <h4 style={{color:"#00359fff",fontWeight:"bolder"}}>Required Documents to Upload <span>{requiredDoc.length}</span> files(s):</h4>
    
       {requiredDoc.length > 0 &&
      requiredDoc.map((doc, file_index) => ( 
      <ul >
        <li className=" ml-3" >{doc.required_documents}</li>
        
      </ul>
  ))}
       <h4  className=" mt-2" style={{color:"#00359fff",fontWeight:"bolder"}}>Additional Information & Guidelines:</h4>
       
       <p>{requiredDoc.length > 0 &&
      requiredDoc.map((doc, file_index) => (<p> {doc.additional_information} </p>))}
The accepted file formats are JPEG, JPG, PNG, and PDF.</p>
  

      </div>
     
    
 </div>
 </div>
</div>
}
{/* upload docs  */}
   <div className="row">
   {requiredDoc.length>0 &&
   <>
    {
      requiredDoc.map((doc,file_index)=>(
        <>
        <div className="col-lg-4 col-md-6">
        <input type="file"  name={doc.required_documents} id={doc.required_documents} style={{display:"none"}} onChange={(e)=>handleFileChange(e,file_index)}  />

        <div className="border  form-control py-3 px-3 text-center" style={{marginRight:"15px",marginTop:"15px",cursor:"pointer"}} onClick={(e)=>handleClickBtnFile(e,doc.required_documents)}>
      <div>
        <div className="d-inline-block"  style={{position:"relative",top:"2px"}}>
      {
       storedDocs[file_index]&& storedDocs[file_index].name?
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-check2-circle" viewBox="0 0 16 16">
  <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0"/>
  <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
</svg>
        :
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
  <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
  <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
</svg>}
</div>
        &nbsp;{doc.required_documents}
        </div>
        </div>
         
        { (formSubmit && storedDocs[file_index] ===null) && <p style={{color:"red"}}>{doc.required_documents}{" is required"}</p>
         }
         </div>
        </>
      ))
    }
   </>
   }

<div className="col-lg-12">
   {
    storedDocs.some((obj)=> obj!==null)?<h3 className="mt-3">Uploaded files </h3>:<></>
   }
</div>


{/*  uploaded document list*/}
</div>
<div className="row mt-2">
{storedDocs.length > 0 && (
  <>
    {storedDocs.map((doc, file_index) => (
      doc?
      <div className="col-lg-4 col-md-6 mb-3" key={file_index}>
      <div className="d-flex justify-content-between w-100 p-3 border" style={{borderRadius:"5px",backgroundColor:"#ece4e4"}}>
        <div className=" pl-3">
          {doc &&doc.name?
          doc.name.length<23?
          doc.name
          :
          doc.name.substring(0,doc.name.lastIndexOf(".")).substring(0,21)+"..."+doc.name.split(".").pop()
           : null}
        </div>
        <div className="text-danger  "  >
        <div style={{cursor:"pointer"}} onClick={()=>handleDeleteFile(file_index)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
</svg>
</div>
        </div>
        </div>
      </div>
      :
      <></>
    ))}
  </>
)}



                {/* passpport country */}
                   {/* <div className='col-lg-4 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Passport Country <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>بلد جواز السفر</span></label>

                   <input
                    type='text'
                    className='form-control'
                    disabled
                    value={formData.passport_country}
                    name='passport_country'
                    onChange={handleChange}
                    onBlur={handleValidation}
                 
                  />
                  
                  {error?.passport_country && <p style={{ color: 'red' }}>{error?.passport_country}</p>}
                </div> */}
                {/* destination_country */}
                    {/* <div className='col-lg-4 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Destination Country <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>بلد المقصد</span></label>

                   <input
                    type='text'
                    className='form-control'
                    disabled
                    value={formData.destination_country}
                    name='destination_country'
                    onChange={handleChange}
                    onBlur={handleValidation}
                 
                  />
                  
                  {error?.destination_country && <p style={{ color: 'red' }}>{error?.destination_country}</p>}
                </div> */}
                {/* visa fee */}
   {/* <div className='col-lg-4 mt-3 '>
  
                  <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>Visa Fee <span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                    <span>رسوم التأشيرة</span></label>

                   <input
                    type='text'
                    className='form-control'
                    disabled
                    value={formData.visa_fee}
                    name='visa_fee'
                    onChange={handleChange}
                    onBlur={handleValidation}
                 
                  />
                  
                  {error?.visa_fee && <p style={{ color: 'red' }}>{error?.visa_fee}</p>}
                </div> */}

{/* statements */}




   

                {/* submit btn */}

                <div className='col-12 mt-4 mb-5'>
                 <button type="button" className="px-5" onClick={(e) => {
                    handleSubmitApplication(e);
                }}>
                    {'Submit Application'}
                </button>
                </div>

                </div>
</div>
}
</div>
                          </div>
                 
  
                      
                  </div>
  
                      </>
                
  
    
              
          
              </form>
  {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <ToastContainer
        position="top-right"     // default
        autoClose={5000}         // 3 sec
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"            // or "dark", "colored"
      />
  
          </Fragment>
  :
  <div style={{
              width: '100vw',
              height: '100vh',
              border: 'none',
              textAlign: 'center',
              marginTop: '25%',
              fontSize: '20px',
              fontWeight: 'bold'
          }}>  {isHidePage == '' ? "Loading" : "Token Invalid"}</div>
      );
    
}

export default EVisaSanad;